import { render } from "./bottomView.vue?vue&type=template&id=05d84bee&scoped=true"
import script from "./bottomView.vue?vue&type=script&lang=js"
export * from "./bottomView.vue?vue&type=script&lang=js"

import "./bottomView.vue?vue&type=style&index=0&id=05d84bee&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d84bee"]])

export default __exports__